import { BaseApi } from "@/api/BaseApi";
import Config from "@/const/Config";
import { BaseOptionWithoutCode } from "@/types/Option";
import { ListData, DetailData, DetailInputData, SearchForm, Syain } from '@/types/Syain'
import { SyozokuSyouninGroup } from "@/types/SyouninGroup";

export class SyainApi extends BaseApi {

  API_PREFIX_CORE = '/syain/core/'
  API_PREFIX_GENERAL = '/syain/general/'
  /**
   * 社員情報一覧を取得します
   * @returns
   */
  public async getList(params: SearchForm): Promise<ListData[]> {
    try {
      const res = await this.post(Config.API_URL + this.API_PREFIX_CORE + "list", params);
      return res.data as ListData[];
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * あるユーザの社員情報を取得します
   * @returns
   */
  public async getInfo(userId: number): Promise<DetailData> {
    try {
      const req = { userId: userId };
      const res = await this.post(Config.API_URL + this.API_PREFIX_CORE + "info", req);
      return res.data as DetailData;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * あるユーザの社員情報を取得します
   * @returns
   */
  public async getInfoForUpdate(req: any): Promise<DetailInputData> {
    try {
      const res = await this.post(Config.API_URL + this.API_PREFIX_CORE + "info", req);
      return res.data as DetailInputData;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 社員マスタを更新します
   * @returns
   */
  public async update(req: DetailInputData): Promise<number> {
    try {
      const res = await this.put<number>(Config.API_URL + this.API_PREFIX_CORE, req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 社員マスタを登録します
   * @returns
   */
  public async create(req: DetailInputData): Promise<number> {
    try {
      const res = await this.post<number>(Config.API_URL + this.API_PREFIX_CORE , req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  public async getAllOptions(){
    try {
      const res = await this.get(Config.API_URL + this.API_PREFIX_CORE + 'options/all')
      return res.data
    } catch (e: any) {
      throw e
    }
  }

  public async getSyozokuSyouninGroup(userId: number): Promise<SyozokuSyouninGroup> {
    try {
      const res = await this.post(Config.API_URL + this.API_PREFIX_CORE + 'syounin_group', {userId: userId});
      return res.data as SyozokuSyouninGroup;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 備考（雇用契約）を更新します
   * @returns
   */
  public async updateKoyouKeiyakuNotes(userId: number, notes: string | null): Promise<DetailData> {
    const req = {
      user_id: userId,
      koyou_keiyaku_notes: notes
    }
    try {
      const res = await this.put(Config.API_URL + this.API_PREFIX_CORE + "update_koyou_keiyaku_notes", req);
      return res.data as DetailData;
    } catch (e: unknown) {
      throw e;
    }
  }


  // 全ユーザーを返します（管理者ロールを除く）
  public async getAllSyain(): Promise<Syain[]> {
    try {
      const res = await this.post<Syain[]>(Config.API_URL + this.API_PREFIX_GENERAL + 'all_syain', null);
      return res.data;
    } catch (e: any) {
      throw e
    }
  }
  
  // 全ユーザーを返します（管理者ロールを除く／オプション値）
  public async getAllSyainOptions(): Promise<BaseOptionWithoutCode[]> {
    try {
      const res = await this.post<BaseOptionWithoutCode[]>(Config.API_URL + this.API_PREFIX_GENERAL +  'options/all_syain', null);
      return res.data;
    } catch (e: any) {
      throw e
    }
  }  
}
